// [2026-10-25] ไอคอน / ชื่อเว็บ / ทางลัดหน้าจอ (ตั้งจาก BO › ตั้งค่าเว็บ)
//   ไอคอน  = "Favicon URL" ใน BO · ไม่ได้ตั้ง → โลโก้เว็บ (imglogo)
//   ชื่อแท็บ = "Title" ใน BO · ถ้าเผลอใส่เป็นลิงก์รูป (https://...) → ใช้ชื่อเว็บแทน (กันชื่อทางลัดเป็น https://s3...)
//   ชื่อทางลัด = ชื่อเว็บ (Description)
//   manifest สร้างใหม่ตามเว็บนี้ (เดิม public/manifest.json เป็นของเว็บอื่น → Android บันทึกแล้วได้ไอคอนเว็บอื่น)
//   จำไว้ใน localStorage → public/index.html ใส่ให้ตั้งแต่ก่อนโหลด React
const LS_KEY = 'site_icon_v1';
const LS_META = 'site_meta_v1';

const isUrl = (s) => /^(https?:)?\/\//i.test(String(s || '').trim()) || /\.(png|jpe?g|webp|gif|svg|ico)(\?|$)/i.test(String(s || '').trim());

function typeOf(url) {
  const u = String(url || '').split('?')[0].toLowerCase();
  if (u.endsWith('.svg')) return 'image/svg+xml';
  if (u.endsWith('.ico')) return 'image/x-icon';
  if (u.endsWith('.jpg') || u.endsWith('.jpeg')) return 'image/jpeg';
  if (u.endsWith('.webp')) return 'image/webp';
  if (u.endsWith('.gif')) return 'image/gif';
  return 'image/png';
}

function upsertLink(rel, href, type) {
  let el = document.querySelector('link[data-site-icon="' + rel + '"]');
  if (!el) {
    document.querySelectorAll('link[rel="' + rel + '"]').forEach((x) => { if (!x.getAttribute('data-site-icon')) x.parentNode.removeChild(x); });
    el = document.createElement('link');
    el.setAttribute('data-site-icon', rel);
    el.rel = rel;
    document.head.appendChild(el);
  }
  if (type) el.type = type; else el.removeAttribute('type');
  if (el.getAttribute('href') !== href) el.href = href;
}
function upsertMeta(name, content) {
  let el = document.querySelector('meta[name="' + name + '"]');
  if (!el) { el = document.createElement('meta'); el.setAttribute('name', name); document.head.appendChild(el); }
  el.setAttribute('content', content);
}

let _manifestUrl = '';
function applyManifest(name, icon) {
  try {
    const origin = window.location.origin;
    const abs = (u) => (/^https?:/i.test(u) ? u : origin + (u.startsWith('/') ? u : '/' + u));
    const m = {
      name, short_name: name.length > 12 ? name.slice(0, 12) : name,
      start_url: origin + '/', scope: origin + '/', display: 'standalone',
      background_color: '#000000', theme_color: '#000000',
      icons: [
        { src: abs(icon), sizes: '192x192', type: typeOf(icon), purpose: 'any' },
        { src: abs(icon), sizes: '512x512', type: typeOf(icon), purpose: 'any' }
      ]
    };
    const url = URL.createObjectURL(new Blob([JSON.stringify(m)], { type: 'application/manifest+json' }));
    let el = document.querySelector('link[rel="manifest"]');
    if (!el) { el = document.createElement('link'); el.rel = 'manifest'; document.head.appendChild(el); }
    el.href = url;
    if (_manifestUrl) { try { URL.revokeObjectURL(_manifestUrl); } catch (e) { /* ignore */ } }
    _manifestUrl = url;
  } catch (e) { /* ignore */ }
}

// เรียกหลังได้ mainsetting: applySiteIcon(favicon, logo, title, webname)
export function applySiteIcon(favicon, logo, title, webname) {
  const icon = String(favicon || logo || '').trim();
  const name = String(webname || '').trim() || (isUrl(title) ? '' : String(title || '').trim()) || document.title || '';
  const tabTitle = !isUrl(title) && String(title || '').trim() ? String(title).trim() : name;
  try {
    if (tabTitle) document.title = tabTitle;
    if (name) upsertMeta('apple-mobile-web-app-title', name); // ชื่อใต้ไอคอนบน iPhone
    upsertMeta('apple-mobile-web-app-capable', 'yes');
    upsertMeta('mobile-web-app-capable', 'yes');
    if (/^https?:\/\//i.test(icon) || icon.startsWith('/')) {
      upsertLink('icon', icon, typeOf(icon));
      upsertLink('apple-touch-icon', icon, null); // iPhone: ไอคอนบันทึกลงหน้าจอ + ช่องค้นหา/ประวัติ
      const tile = document.querySelector('meta[name="msapplication-TileImage"]');
      if (tile) tile.setAttribute('content', icon);
      localStorage.setItem(LS_KEY, icon);
      applyManifest(name || 'Web', icon);
    }
    localStorage.setItem(LS_META, JSON.stringify({ name, title: tabTitle }));
  } catch (e) { /* ignore */ }
  try { setupInstallPrompt(icon, name); } catch (e) { /* ignore */ }
}

// ===== ปุ่ม "เพิ่มทางลัดไว้หน้าจอ" (มือถือเท่านั้น) =====
//   Android (Chrome/Samsung): กดปุ่ม → หน้าต่างติดตั้งของเครื่อง (ถ้าเครื่องยังไม่พร้อม → บอกวิธีกดเมนู ⋮)
//   iPhone/iPad (Safari): ไม่มีคำสั่งให้เว็บติดตั้งเอง → แสดงวิธีกด แชร์ › เพิ่มไปยังหน้าจอโฮม
//   ติดตั้งแล้ว / เปิดจากทางลัด → ไม่แสดง · กดปิด → ไม่แสดงอีก 3 วัน
//   [2026-10-25] z-index สูงกว่า iframe หน้าแรก (2147482000) — เดิม 99990 เลยถูก iframe ทับมองไม่เห็น · ภาษาตามเว็บ (ไทย/ลาว/อังกฤษ)
let _deferred = null;
let _setup = false;
const DISMISS_KEY = 'a2hs_dismiss_v2';
const TX = {
  th: { title: 'เพิ่มทางลัดไว้หน้าจอ', sub: 'เปิดเว็บได้ทันทีเหมือนแอป', how: 'วิธีเพิ่ม', install: 'ติดตั้ง', close: 'ปิด', ok: 'เข้าใจแล้ว', addTo: 'เพิ่ม {n} ไว้หน้าจอ', thisWeb: 'เว็บนี้',
    a1: 'กดปุ่ม {k} มุมขวาบนของ Chrome', a2: 'กด <b>เพิ่มลงในหน้าจอหลัก</b> (หรือ <b>ติดตั้งแอป</b>)', a3: 'กด <b>เพิ่ม</b>', aNote: 'ถ้าเปิดจากแอปอื่น เช่น LINE ให้กดเปิดด้วย Chrome ก่อน',
    i1: 'กดปุ่ม {k} แชร์ (ล่างจอ หรือบนขวา)', i2: 'เลื่อนลงแล้วกด {k} <b>เพิ่มไปยังหน้าจอโฮม</b>', i3: 'กด <b>เพิ่ม</b> มุมขวาบน', iNote: 'ต้องเปิดด้วย Safari (ถ้าเปิดจากแอปอื่น เช่น LINE ให้กดเปิดใน Safari ก่อน)' },
  lo: { title: 'ເພີ່ມທາງລັດໄວ້ໜ້າຈໍ', sub: 'ເປີດເວັບໄດ້ທັນທີຄືແອັບ', how: 'ວິທີເພີ່ມ', install: 'ຕິດຕັ້ງ', close: 'ປິດ', ok: 'ເຂົ້າໃຈແລ້ວ', addTo: 'ເພີ່ມ {n} ໄວ້ໜ້າຈໍ', thisWeb: 'ເວັບນີ້',
    a1: 'ກົດປຸ່ມ {k} ມຸມຂວາເທິງຂອງ Chrome', a2: 'ກົດ <b>ເພີ່ມໃສ່ໜ້າຈໍຫຼັກ</b> (ຫຼື <b>ຕິດຕັ້ງແອັບ</b>)', a3: 'ກົດ <b>ເພີ່ມ</b>', aNote: 'ຖ້າເປີດຈາກແອັບອື່ນ ເຊັ່ນ LINE ໃຫ້ກົດເປີດດ້ວຍ Chrome ກ່ອນ',
    i1: 'ກົດປຸ່ມ {k} ແບ່ງປັນ (ລຸ່ມຈໍ ຫຼື ເທິງຂວາ)', i2: 'ເລື່ອນລົງແລ້ວກົດ {k} <b>ເພີ່ມໃສ່ໜ້າຈໍໂຮມ</b>', i3: 'ກົດ <b>ເພີ່ມ</b> ມຸມຂວາເທິງ', iNote: 'ຕ້ອງເປີດດ້ວຍ Safari (ຖ້າເປີດຈາກແອັບອື່ນ ເຊັ່ນ LINE ໃຫ້ກົດເປີດໃນ Safari ກ່ອນ)' },
  en: { title: 'Add to Home Screen', sub: 'Open the site instantly like an app', how: 'How to add', install: 'Install', close: 'Close', ok: 'Got it', addTo: 'Add {n} to your Home Screen', thisWeb: 'this site',
    a1: 'Tap {k} at the top right of Chrome', a2: 'Tap <b>Add to Home screen</b> (or <b>Install app</b>)', a3: 'Tap <b>Add</b>', aNote: 'If opened inside another app (e.g. LINE), open it in Chrome first',
    i1: 'Tap the Share button {k} (bottom or top right)', i2: 'Scroll down and tap {k} <b>Add to Home Screen</b>', i3: 'Tap <b>Add</b> at the top right', iNote: 'Must be opened in Safari (if inside another app like LINE, open in Safari first)' }
};
function tx() {
  let l = 'th';
  try { l = String(localStorage.getItem('lang') || document.documentElement.lang || 'th').toLowerCase().slice(0, 2); } catch (e) { /* ignore */ }
  if (l === 'la') l = 'lo';
  return TX[l] || (l === 'th' ? TX.th : TX.en);
}
function isMobile() { return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); }
function isIOS() { return /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); }
function isStandalone() { return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true; }
function dismissed() { try { return Date.now() - Number(localStorage.getItem(DISMISS_KEY) || 0) < 3 * 86400e3; } catch (e) { return false; } }

function css() {
  if (document.getElementById('a2hs-css')) return;
  const st = document.createElement('style');
  st.id = 'a2hs-css';
  st.textContent = `
#a2hs-bar{position:fixed;left:10px;right:10px;bottom:calc(92px + env(safe-area-inset-bottom));z-index:2147482600;display:flex;align-items:center;gap:10px;max-width:520px;margin:0 auto;
 padding:10px 12px;border-radius:14px;background:rgba(15,15,20,.96);color:#fff;box-shadow:0 8px 28px rgba(0,0,0,.55);font-size:14px;border:1px solid rgba(255,255,255,.14);animation:a2hsIn .3s ease-out}
@keyframes a2hsIn{from{transform:translateY(20px);opacity:0}to{transform:none;opacity:1}}
#a2hs-bar img{width:40px;height:40px;border-radius:10px;object-fit:cover;background:#000;flex:0 0 auto}
#a2hs-bar .t{flex:1;line-height:1.25;min-width:0}#a2hs-bar .t b{display:block;font-size:14.5px}#a2hs-bar .t span{font-size:12px;opacity:.75}
#a2hs-bar button{border:0;border-radius:10px;padding:8px 12px;font-weight:700;font-size:13.5px;cursor:pointer;white-space:nowrap}
#a2hs-go{background:linear-gradient(180deg,#ffd45a,#e3a10a);color:#1a1200}#a2hs-x{background:transparent;color:#fff;opacity:.7;padding:6px 8px!important}
#a2hs-ios{position:fixed;inset:0;z-index:2147483100;background:rgba(0,0,0,.6);display:flex;align-items:flex-end;justify-content:center}
#a2hs-ios .s{width:100%;max-width:480px;background:#16161c;color:#fff;border-radius:18px 18px 0 0;padding:18px 18px calc(18px + env(safe-area-inset-bottom));font-size:15px}
#a2hs-ios .s h4{margin:0 0 12px;font-size:17px;color:#fff}#a2hs-ios ol{margin:0;padding-left:22px;line-height:1.9}
#a2hs-ios .k{display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:7px;background:#2b2b35;vertical-align:middle;margin:0 2px}
#a2hs-ios .c{margin-top:14px;width:100%;border:0;border-radius:12px;padding:11px;font-weight:700;background:#2b2b35;color:#fff;font-size:15px}`;
  document.head.appendChild(st);
}
const SHARE_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4da3ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="M7 8l5-5 5 5"/><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/></svg>';
const PLUS_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M12 8v8M8 12h8"/></svg>';
const K = (h) => '<span class="k">' + h + '</span>';

export function showInstallHelp(name, android) {
  css();
  if (document.getElementById('a2hs-ios')) return;
  const T = tx();
  const w = document.createElement('div');
  w.id = 'a2hs-ios';
  const nm = name ? String(name).replace(/[<>&"]/g, '') : T.thisWeb;
  const steps = android
    ? [T.a1.replace('{k}', K('<b>⋮</b>')), T.a2, T.a3]
    : [T.i1.replace('{k}', K(SHARE_SVG)), T.i2.replace('{k}', K(PLUS_SVG)), T.i3];
  w.innerHTML = '<div class="s"><h4>' + T.addTo.replace('{n}', nm) + '</h4><ol>' + steps.map((x) => '<li>' + x + '</li>').join('') + '</ol>'
    + '<div style="font-size:12.5px;opacity:.7;margin-top:8px">' + (android ? T.aNote : T.iNote) + '</div>'
    + '<button class="c" type="button">' + T.ok + '</button></div>';
  w.addEventListener('click', (e) => { if (e.target === w || e.target.classList.contains('c')) w.remove(); });
  document.body.appendChild(w);
}
function hideBar(remember) {
  const b = document.getElementById('a2hs-bar');
  if (b) b.remove();
  if (remember) { try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) { /* ignore */ } }
}
// กดติดตั้ง/วิธีเพิ่ม — เรียกจากปุ่มอื่นในเว็บได้ด้วย: window.bwInstallShortcut()
async function doInstall(name) {
  if (isIOS()) { showInstallHelp(name, false); return; }
  if (!_deferred) { showInstallHelp(name, true); return; }
  _deferred.prompt();
  try { const r = await _deferred.userChoice; if (r && r.outcome === 'accepted') hideBar(true); } catch (e) { /* ignore */ }
  _deferred = null;
}
function showBar(icon, name) {
  if (document.getElementById('a2hs-bar') || isStandalone() || dismissed() || !isMobile()) return;
  const T = tx();
  css();
  const b = document.createElement('div');
  b.id = 'a2hs-bar';
  b.innerHTML = (icon ? '<img alt="" src="' + String(icon).replace(/"/g, '') + '">' : '') + '<div class="t"><b>' + T.title + '</b><span>' + T.sub + '</span></div>'
    + '<button id="a2hs-go" type="button">' + (isIOS() || !_deferred ? T.how : T.install) + '</button><button id="a2hs-x" type="button" aria-label="' + T.close + '">✕</button>';
  document.body.appendChild(b);
  b.querySelector('#a2hs-x').onclick = () => hideBar(true);
  b.querySelector('#a2hs-go').onclick = () => doInstall(name);
}
export function setupInstallPrompt(icon, name) {
  window.__a2hs = { icon, name };
  window.bwInstallShortcut = () => { const a = window.__a2hs || {}; doInstall(a.name); };
  if (_setup) { showBar(icon, name); return; }
  _setup = true;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    _deferred = e;
    const a = window.__a2hs || {};
    const go = document.getElementById('a2hs-go');
    if (go) go.textContent = tx().install; else showBar(a.icon, a.name);
  });
  window.addEventListener('appinstalled', () => hideBar(true));
  setTimeout(() => { const a = window.__a2hs || {}; showBar(a.icon, a.name); }, 2500);
}

export default applySiteIcon;
